import { AvailabilityQuery, PropertyPageQuery } from 'gql/graphql'
import Headers from 'components/home/common/typography/Headers'
import PublicMobileModal from 'components/PublicMobileModal'
import { ModalProps } from 'data/types/modal'
import BookingConditionsMobile from 'components/property/booking-conditions/BookingConditionsMobile'

export interface BookingConditionsModalProps extends ModalProps {
  property: NonNullable<PropertyPageQuery['property']>
  availability: AvailabilityQuery['availability']
}

const BookingConditionsModal = ({
  isOpen,
  onClose,
  ...props
}: BookingConditionsModalProps) => {
  return (
    <PublicMobileModal
      isOpen={isOpen}
      onClose={onClose}
      className={{
        panel: '!max-w-[500px] lg:!h-full',
      }}
    >
      <div className="flex flex-col px-24 py-18">
        <Headers.H1 Tag="h3" className="text-center leading-28 mb-30">
          Booking Conditions
        </Headers.H1>

        <BookingConditionsMobile {...props} />
      </div>
    </PublicMobileModal>
  )
}

export default BookingConditionsModal
